
<template>
<vs-row vs-justify="center">
  <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <div class="vx-col sm:w-2/2 mb-2 mt-5">
                <vs-row vs-w="12">
                    <vs-col  vs-justify="center" vs-align="center" vs-w="6">
                        <h3>LISTA COMPLETA POR ESTUDIANTE</h3>
                        <span>Seleccione un estudiante</span>
                        <v-select  placeholder="Listado de estudiantes" v-model="selectStudent"  label="nombre_completos" :options="listStudents" 
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"  :click="obtenerListado" />
                    </vs-col>
                    <vs-col  vs-justify="center" vs-align="center" vs-w="6" style="padding-left:12px">
                        <h3>Tabla de Refencias:</h3>
                        <vs-row vs-w="12" style="border: 1px solid #f3f3f3; ">
                          <vs-row vs-w="12" >
                            <vs-col vs-type="flex" style="border: 3px solid #f3f3f6;" vs-justify="center" vs-align="center" vs-w="8">
                              Obligatorio
                            </vs-col>
                            <vs-col vs-type="flex" style="border: 3px solid #f3f3f6; background:rgb(40,199,111)"  vs-justify="center" vs-align="center" vs-w="4">
                            </vs-col>
                          </vs-row>
                          <vs-row vs-w="12">
                            <vs-col vs-type="flex" style="border: 3px solid #f3f3f6;" vs-justify="center" vs-align="center" vs-w="8">
                              Sin Stock
                            </vs-col>
                            <vs-col vs-type="flex" style="border: 3px solid #f3f3f6; background:rgb(234,84,85)" back vs-justify="center" vs-align="center" vs-w="4">
                            </vs-col>
                          </vs-row>
                          <vs-row vs-w="12">
                            <vs-col vs-type="flex" style="border: 3px solid #f3f3f6;" vs-justify="center" vs-align="center" vs-w="8">
                              Producto ya comprado
                            </vs-col>
                            <vs-col vs-type="flex" style="border: 3px solid #f3f3f6; background:rgb(255,186,0)" back vs-justify="center" vs-align="center" vs-w="4">
                            </vs-col>
                          </vs-row>
                        </vs-row>
                    </vs-col>
                </vs-row>
                <vs-row vs-w="6">
                </vs-row>
            </div>
            <vs-row class="mt-4">
              <vs-col vs-w="12">
                <div class="vx-card p-3" style="
                    background: #FFF3CD;
                    border-left: 5px solid #FFC107;
                    color: #000;
                    border-radius: 6px;
                ">
                  <div class="d-flex align-center">
                    <i class="material-icons mr-2" style="color:#FFC107;">warning</i>
                    <span>
                      Favor <strong>revisar en casa</strong> el kit de robótica del año pasado 
                      para poder seleccionar el <strong>Kit de Expansión o Kit Completo</strong> 
                      para este año lectivo.
                    </span>
                  </div>
                </div>
              </vs-col>
            </vs-row>
            <br>
            <!-- <vs-chip color="primary" >
              <vs-avatar icon="notifications" />
              Mención: <label  style="color:white!important;" v-text="nombreMencion"/>
            </vs-chip> -->
             <div class="vx-col sm:w-2/2 mb-2">
              <vs-row vs-justify="flex-end">
                      <vs-button  data-toggle="tooltip" data-placement="bottom" title="Agregar todos los productos" data-original-title="Agregar todos los productos"  type="border" size="small" icon-pack="feather"  class="mr-1" @click="validarCarrito()">
                              <i class="material-icons" >
                                shopping_basket
                              </i>
                      </vs-button>
              </vs-row>
            </div>
             <div class="vx-col sm:w-1/2 mb-2">
            </div>
            <vs-table 
              pagination
              max-items="100"
              search
              :data="listCompleteDetalle">
              <template slot="header">
                <h3>
                </h3>
              </template>
              <template slot="thead">
                <vs-th class="con-vs-checkbox">
                  <vs-checkbox
                    v-model="allCheck"
                    @change="checkAll()"
                  />
                </vs-th>
                <vs-th sort-key="nom_producto">
                  PRODUCTO
                </vs-th>
                <vs-th sort-key="quantity">
                  CANTIDAD
                </vs-th>
                <vs-th sort-key="price">
                  PRECIO
                </vs-th>
                <vs-th sort-key="OPCIONES">
                  OPCIONES
                </vs-th>
              </template>

              <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  
                  :state="statusPreventa  ? 'success' : 
                  ( tr.producto_obligatorio == 'S' ?'success':
                    ( (tr.controla_stock == 'S' && tr.stock -5 > 0) ? '' : 
                        ((tr.stock-5) <= 0 && tr.controla_stock == 'S' ? 'danger' : 
                         (tr.comprado) == 1 ? 'warning' : ''
                        )
                        )
                  
                  )">

                  <vs-td class="con-vs-checkbox">
                    <vs-checkbox  v-model="data[indextr].checked" :disabled="statusPreventa ? true : data[indextr].producto_obligatorio === 'S' ? true : false" @change="checkOne(tr)"/>
                  </vs-td>

                <!-- <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" 
                  :state="statusPreventa  ? 'success' : 
                  ( tr.producto_obligatorio == 'S' ?'success':
                    (tr.controla_stock == 'S' ? '' : 
                        ((tr.stock-5)  <= 0 && tr.controla_stock == 'S' ? 'danger' : '')
                        )
                  
                  )"> -->

                  <vs-td :data="data[indextr].nom_producto">
                    {{data[indextr].nom_producto}}
                    <p  v-if="isInCart(tr)" class="productoExistente">
                        Producto ya seleccionado
                    </p>
                  </vs-td>

                  <vs-td :data="data[indextr].cantidad">
                    {{parseInt(data[indextr].cantidad)}}
                  </vs-td>

                  <vs-td :data="data[indextr].precio_act">
                     {{parseFloat(data[indextr].precio_act).toFixed(2)}} 
                    <!-- {{parseFloat(data[indextr].precio_act)}} -->
                  </vs-td>
                  <vs-td>
                    <vs-button type="border" size="small" icon-pack="feather" :disabled="statusPreventa" class="mr-2" @click="cartButtonClicked(tr,true)">
                    <i class="material-icons"  v-if="!isInCart(tr)">
                      add_shopping_cart
                    </i>
                    <i class="material-icons"  v-else>
                      shopping_cart
                    </i>
                    </vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

             <!-- <input type="hidden" v-text="unSelected"> -->
      </vs-col>
          <vs-popup class="holamundo" title="Agregar productos" :active.sync="popupAceptCartAll">
              <p>¿Está seguro de agregar {{ sizeSelected }} productos   al  estudiante <b> {{(selectStudent == null ) ? null : selectStudent.nombre_completos   }}</b>?
                  <br>
              </p>
              <div class="flex flex-wrap justify-between mb-3">
                  <vs-button  color="success" @click="cartButtonAllClicked()">Aceptar</vs-button>
                  <vs-button  color="danger"  @click="(popupAceptCartAll = !popupAceptCartAll),((statusPreventa != true) ? (selected = []) : null)">Cancelar</vs-button>
              </div>
          </vs-popup>
            <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
                   <div class="flex flex-wrap justify-between my-5">
                      {{ (mensaje) == null ? null : mensaje }}
                   </div>      
                    <div class="flex flex-wrap justify-center mb-3">
                        <vs-button  color="primary" @click="popupMensaje = !popupMensaje">Aceptar</vs-button>
                    </div>
            </vs-popup>  
  </vs-row>
</template>

<script>
export default {
    data(){
        return {
          popupAceptCartAll:false,
          sizeSelected:0,
          selectStudent: (localStorage.getItem('student') == null ) ? ({nombre_completos:'', id_usuario_estudiante : null }) : JSON.parse(localStorage.getItem('student')),
          listStudents:[],
          selected:[],
          popupMensaje:false,
          mensaje:'',
          clonPreventa:[],
          listCompleteDetalle:[],
          nombreMencion:"",
          productosObligatorios:[],
          response:[],
          allCheck: false
        }
    },
    computed:{
      /* allCheck:{
        get(value){
          console.log(value,'get');
          return this.listCompleteDetalle ? this.selected.length === this.listCompleteDetalle.length : false;
        },
        set(value){
          console.log(value,'value');
          const select = [];
          this.listCompleteDetalle.forEach(producto=>{
            if(value){
              select.push(producto); producto.selected = true
            }else{
              producto.selected = producto.producto_obligatorio === 'S' ? true : false;
            }
          });
          this.selected = select;
        }
      }, */
        statusPreventa(){
          if(!_.isEmpty(localStorage.getItem('statusPreventa')))
            return  JSON.parse(localStorage.getItem('statusPreventa'));
          else{
            return false;
          }
        },
        // PROFILE
        activeUserInfo() {
          return this.$store.state.AppActiveUser
        },
        isInCart() {
          return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
        },
        unSelected(){
          var productos = this.selected;
          var _this = this;
          if(!this.statusPreventa){
            _.remove(productos, function(o) {
              // if( (o.controla_stock == 'S' && o.stock -5 <= 0 )){
                if( (o.controla_stock == 'S' && o.stock -5 <= 0 ) || o.cantidad == 0 ||  o.cantidad == '0.0000'){
                  return true;
                  }
                  if(_this.isInCart(o)){
                    return true;
                    
                  }else{
                    return false;
                  }
                  
                  // console.log(o.stock -5 <= 0 , o.controla_stock);
                  // // if(_this.isInCart(o) && o.stock-5  == 0 && o.controla_stock != 'S'){
                    // if(_this.isInCart(o) && o.stock-5  <= 0 && o.controla_stock == 'S'){
                      //   return true;
                  // }else{
                    //   return false;
                  // }

              });
          }
          const union = _.concat(this.selected,this.productosObligatorios);
          this.selected = _.uniq(union);
          this.sizeSelected = _.size(productos);
          return productos;
        },
        obtenerListado(){
        this.nombreMencion = "";
        var selectStudent  = this.selectStudent;
        // this.listCompleteDetalle = [];
        this.$store.dispatch('student/selectedStudent',selectStudent);
        if(!_.isEmpty(selectStudent)){
          if(!_.isEmpty(selectStudent.numero_identificacion)){
              this.$vs.loading();
              axios.post(this.$store.state.domain+`mapgrafi/estudiante/lista-completa-carga-general`,{
                  numero_identificacion  : selectStudent.numero_identificacion,
                  cod_bodega: null,
                  id_usuario: this.activeUserInfo.id_usuario,
                  cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
                  cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO
                })
                .then((response) => { 
                  this.$vs.loading.close();
                  if(response.status != 200) throw 'ERROR EN EL SERVIDOR';
                    else if((response.data.existeError)) throw response.data.mensaje;
                      else if(!_.isEmpty(response.data.data)){
                          let _this   = this;
                            _this.nombreMencion = response.data.data.nombre_mencion;
                            const copy = _.map(response.data.data.listadoProductos, (o) => {
                                return {
                                  ...o,
                                  quantity              : o.cantidad,
                                  id_estudiante         : selectStudent.id_estudiante,
                                  id_usuario_estudiante : selectStudent.id_usuario_estudiante,
                                  cod_persona           : selectStudent.cod_persona,
                                  cod_matricula         : selectStudent.cod_matricula,
                                  student               : selectStudent,
                                  porcentaje_descuento  : this.statusPreventa ? JSON.parse(localStorage.getItem('discount_post')) : 0,
                                  isProductPreventa     : this.statusPreventa,
                                  nombre_completos      : selectStudent.nombre_completos,
                                  checked: this.statusPreventa ? true : o.producto_obligatorio === 'S' ? true: false
                                }
                            })
                            
                          if(this.statusPreventa){
                            this.clonPreventa= _.clone(copy);
                            this.listCompleteDetalle = _.clone(this.clonPreventa);
                            this.selected            = _.clone(this.clonPreventa);
                            this.productosObligatorios = _.clone(this.clonPreventa);
                            this.sizeSelected = _.size(this.selected);
                          }else{
                              this.listCompleteDetalle = copy;
                              this.productosObligatorios =  this.listCompleteDetalle.filter(detalle=>detalle.producto_obligatorio === 'S');
                              this.selected = this.productosObligatorios;
                            this.sizeSelected = _.size(this.selected);
                          }

                          
                      }
                })
                .catch((error)=>{
                    this.$vs.loading.close();
                    this.mensaje = 'No tiene permitido realizar compras con el estudiante, no está matriculado.';
                    this.popupMensaje = true;
                });
          }else{
            this.listCompleteDetalle = [];
            this.productosObligatorios = [];
            this.sizeSelected =0
          }
        }else{
            this.listCompleteDetalle = [];
            this.productosObligatorios = [];
            this.sizeSelected =0
        }
      },
    },
    methods:{
      validarCarrito(){
        try {
          if(this.statusPreventa)
            if(!(_.size(this.selected) === _.size(this.clonPreventa))) throw 'Debe seleccionar todos los productos';
              this.popupAceptCartAll = !this.popupAceptCartAll;
        } catch (error) {
          this.mensaje = error;
          this.popupMensaje = true;
        }
      },
      additemInCart(item) {
        let { cantidad, controla_stock, stock } = item
        cantidad  = ~~cantidad
        stock     = ~~stock
        if(cantidad == 0 ){
          this.mensaje      = "No se puede seleccionar ese producto."
          this.popupMensaje = true
          return
        }else if(!this.statusPreventa){
          if(controla_stock == 'S'){
            if(stock-5 < cantidad){
              this.mensaje      = "Producto sin stock, no se puede agregar al carrito de compras."
              this.popupMensaje = true
              return 
            }
          }
        }

        this.$store.dispatch('eCommerce/additemInCart', item)
        
      },
      cartButtonClicked(item,guardarCarritoJson) {
        console.log('pasa')
        this.isInCart(item) ? this.removeItemFromCart(item) : (this.additemInCart(item))
        if (guardarCarritoJson) {
          this.verifyCart();
          this.$http.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                    evento    : "GUARDAR",
                    id_usuario: this.activeUserInfo.id_usuario,
                    carrito   : (localStorage.getItem('carItems')),
                    cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
            })
            .then((response) => {
                this.$vs.loading.close(); 
            })
            .catch(() => {
                this.$vs.loading.close(); 
            })
        }
      },
      cartButtonAllClicked(){
        var selected  = this.selected;
        var _this = this;
        if(!_.isEmpty(selected)){
          _.forEach(selected,function(o){
              // var stock = o.stock -5;
              //   if(!_this.statusPreventa){
              //     if((stock) > 0 && stock >= o.quantity){
              //       _this.cartButtonClicked(o);
              //     }
              //   }else{
                  if (o.cantidad > 0 && o.cantidad != '0.0000') {
                      _this.cartButtonClicked(o,false);
                  }
                // }
          });
          this.selected = [];
          this.popupAceptCartAll = false;
          this.verifyCart();
          this.$http.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                    evento    : "GUARDAR",
                    id_usuario: this.activeUserInfo.id_usuario,
                    carrito   : (localStorage.getItem('carItems')),
                    cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
            })
            .then((response) => {
                this.$vs.loading.close(); 
            })
            .catch(() => {
                this.$vs.loading.close(); 
            });
        }
      },

      verifyCart() {
        const { objectID, cod_clasificacion } = JSON.parse(localStorage.getItem('transporte')); // objectID , cod_clasificacion
        let datosCarrito = JSON.parse(localStorage.getItem('carItems'));
        datosCarrito = _.groupBy(datosCarrito, 'id_estudiante');

        _.forEach(datosCarrito, (estudiante) => {
          let contador = 0;
          let datosTransporte = null;
          _.forEach(estudiante, (p) => {
            contador++;
            if (p.cod_clasificacion == cod_clasificacion && p.objectID == objectID){
              datosTransporte = p;
            }
          })

          if (contador == 1 && datosTransporte) {
            this.removeItemFromCart(datosTransporte);
          }
        })

      },

      removeItemFromCart(item) {
        this.$store.dispatch('eCommerce/toggleItemInCart', item)
      },
      loadGeneralStudens(){
        var _this = this;
          var playLoad = {
            "id_usuario": this.$store.state.AppActiveUser.id_usuario,
              "cod_persona":this.$store.state.AppActiveUser.cod_persona,
              "estado":"A"

          }
          this.$vs.loading();
          this.$store.dispatch('student/loadGeneral', playLoad)
          .then((response) => { this.$vs.loading.close() 
                  _this.listStudents  =     response.data.data;
          })
          .catch(error => {
            this.$vs.loading.close()
            this.mensaje = error.message;
            this.popupMensaje = true;
          })
      },
      validatePreventa(){
          var  fecha_preventa =   JSON.parse(localStorage.getItem('date_pre_sale'));
          var statusPreventa   = this;
          let pro = new Promise((resolve, reject) => {
              axios.get(this.$store.state.domain+`mapgrafi/mapgrafi-general/obtener-fecha`)
              .then((response) => {
                resolve(response);
              })
          });
          pro.then((response) => {
            // aqui puedo validar lo de preventa
            statusPreventa  = moment(response.data).isBetween(fecha_preventa.fechaDesde, fecha_preventa.fechaHasta, null, '[]'); //truereturn true
            localStorage.removeItem('statusPreventa');
            localStorage.setItem('statusPreventa',JSON.stringify(statusPreventa));
          });

      },
      validatorOnline(){
          if(!this.$store.state.AppActiveUser.status)
            this.$router.push('/');
            else{
              this.validatePreventa();
              this.loadGeneralStudens();
            }
      },
      selectionOn(val){
        return this.productosObligatorios.includes(val) ? true : false;
      },
      checkAll(){
        const selecteds = [];
        this.listCompleteDetalle.forEach(producto=>{
            if(this.allCheck){
              producto.checked = true;
              if(Number(producto.cantidad) !== 0){
                 selecteds.push(producto);
              }
            }else{
              if(producto.producto_obligatorio === 'S'){
                producto.checked = true;
                selecteds.push(producto);
              }else{
                producto.checked = false;
              }
              this.selected = [];
            }
          });
        const union = _.concat(selecteds,this.selected);
        this.selected = _.uniq(union);
        this.sizeSelected = _.size(this.selected);
      },
      checkOne(value){
        if(value.checked === true && value.cantidad != 0){
          if(!this.selected.includes(value)){
            this.selected.push(value);
          } 
        }else{
          this.selected = this.selected.filter(val=>val.cod_producto !== value.cod_producto);
        }

        this.sizeSelected = _.size(this.selected);
      }
    },
    created(){
      this.validatorOnline();
    }
}
</script>
<style>
.productoExistente{
    width: auto;
    background: aliceblue;
    font-weight: bold;
    color: red;
}

</style>